import type { FC } from "react";
import React, { useEffect } from "react";
import { useDatalayerTracking } from "@edreamsodigeo/frontend-core";

import useMembershipProductQuery from "~/clientState/hooks/useMembershipProductQuery";
import { SubscriptionOfferType } from "../../../generated/graphql";

const PrimeAddedDatalayer: FC = () => {
  const { data } = useMembershipProductQuery();
  const { save: saveDatalayer } = useDatalayerTracking();

  const membershipProduct = data?.membershipProduct;

  useEffect(() => {
    if (membershipProduct !== undefined) {
      const primeAdded =
        membershipProduct?.offerAdded.type === SubscriptionOfferType.Basic ||
        membershipProduct?.offerAdded.type === SubscriptionOfferType.Plus;
      saveDatalayer({
        prime_added: primeAdded.toString(),
      });
    }
    //TODO: to be fixed by OPTIMUS
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [membershipProduct]);

  return <></>;
};
export default PrimeAddedDatalayer;
